export const TABS = {
  ACCOUNT: 'account',
  SHOP: 'shop',
}

